module.exports = __webpack_public_path__ + "img/logo-img.e2bdadb6.svg";